export enum PlatformEnums {
  PIN= 'pin',
  CON = 'con',
  ZA = 'za',
}

export enum PlatformEnum {
  CON_ARGENTINA = 'con-ar',
  CON_BELGIAN = 'con-be',
  CON_BRAZIL = 'con-br',
  CON_CHILE = 'con-cl',
  CON_COLOMBIA = 'con-co',
  CON_DEUTSCHLAND = 'con-de',
  CON_FRANCE = 'con-fr',
  CON_ITALY = 'con-it',
  CON_MEXICO = 'con-mx',
  CON_PERU = 'con-pe',
  CON_PORTUGAL = 'con-pt',
  CON_SPAIN = 'con-es',
}

export enum PlatformCountryEnum {
  CON_ARGENTINA = 'AR',
  CON_BRAZIL = 'BR',
  CON_CHILE = 'CL',
  CON_COLOMBIA = 'CO',
  CON_DEUTSCHLAND = 'DE',
  CON_FRANCE = 'FR',
  CON_ITALY = 'IT',
  CON_MEXICO = 'MX',
  CON_PERU = 'PE',
  CON_PORTUGAL = 'PT',
  CON_SPAIN = 'ES',
}
